import { Link } from 'react-router-dom';
import AdPlacement from './AdPlacement';

function Footer() {
  return (
    <footer className="bg-gray-800 border-t border-gray-700"> {/* Removed md:hidden */}
      <div className="container mx-auto px-4 py-6">
        {/* Footer Ad Placement */}
        <div className="mb-6">
          <AdPlacement id={101} />
        </div>
        
        <div className="text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} Date & Time Central. All rights reserved.</p>
          <div className="mt-4 flex justify-center space-x-4">
            <Link to="/privacy-policy" className="hover:text-gray-300">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-gray-300">Terms of Service</Link>
            <Link to="/about-us" className="hover:text-gray-300">About Us</Link>
            <Link to="/contact" className="hover:text-gray-300">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;